/* global
actualCostsCreateUrl configsUrl generateReportUrl
previewCachedUrl previewRefreshUrl
reportConfigsIndexUrl reportConfigsStoreUrl reportConfigsDeleteUrl
locationType
actualCostsReportsIndexUrl actualCostsReportsShowUrl actualCostsReportsDeleteUrl actualCostsReportsRefreshUrl actualCostsReportsChannelName actualCostsReportsPruningDays
*/

import React, { useState, useCallback } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ActualVsBudgetReport from '../actual_vs_budget_report/ActualVsBudgetReport';
import { ActualVsBudgetReportProvider } from '../actual_vs_budget_report/context/ActualVsBudgetReportContext';

import ArchivedActualCostsReports from './archived_reports/ArchivedActualCostsReports';

import Tabs, { RenderStrategyOnFirstVisit } from 'CommonComponents/Tabs';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { ToastProvider } from 'Context/ToastContext';

const REPORTS_TAB_ID = 'reports';

const DepartmentActualsReportTabs = () => {
    const [activeTab, setActiveTab] = useState('generate_report');

    const switchToReportsTab = useCallback(() => {
        setActiveTab(REPORTS_TAB_ID);
    }, []);

    const tabs = [
        {
            id: 'generate_report',
            title: $t('Generate Report'),
            content: () => (
                <ActualVsBudgetReportProvider
                    fetchConfigsUrl={configsUrl}
                    module={locationType}
                    actualCostsCreateUrl={actualCostsCreateUrl}
                    generateReportUrl={generateReportUrl}
                    previewCachedUrl={previewCachedUrl}
                    previewRefreshUrl={previewRefreshUrl}
                    reportConfigsIndexUrl={reportConfigsIndexUrl}
                    reportConfigsStoreUrl={reportConfigsStoreUrl}
                    reportConfigsDeleteUrl={reportConfigsDeleteUrl}
                    onReportGenerated={switchToReportsTab}
                >
                    <ActualVsBudgetReport />
                </ActualVsBudgetReportProvider>
            ),
        },
        {
            id: REPORTS_TAB_ID,
            title: $t('Reports'),
            content: () => (
                <ToastProvider>
                    <ConfirmationModalProvider>
                        <ArchivedActualCostsReports
                            actualCostsReportsIndexUrl={actualCostsReportsIndexUrl}
                            actualCostsReportsShowUrl={actualCostsReportsShowUrl}
                            actualCostsReportsDeleteUrl={actualCostsReportsDeleteUrl}
                            actualCostsReportsRefreshUrl={actualCostsReportsRefreshUrl}
                            channelName={actualCostsReportsChannelName}
                            pruningDays={actualCostsReportsPruningDays}
                        />
                    </ConfirmationModalProvider>
                </ToastProvider>
            ),
        },
    ];

    return <Tabs tabs={tabs} activeTab={activeTab} onTabActivate={setActiveTab} renderStrategy={RenderStrategyOnFirstVisit} />;
};

if (document.getElementById('DepartmentActualsReportTabs')) {
    ReactDOM.render(
        <App>
            <DepartmentActualsReportTabs />
        </App>,
        document.getElementById('DepartmentActualsReportTabs'),
    );
}

export default DepartmentActualsReportTabs;
